import './ChallengeRoadmap.css';

const STEPS = [
  {
    id: 'create',
    title: 'Create challenge',
    detail:
      'Pick a game, set your stake, and define the rules. You confirm with your wallet—EWIO records the challenge on-chain.',
  },
  {
    id: 'invite',
    title: 'Invite opponent',
    detail:
      'Share your challenge link. Your opponent reviews the same terms before they can join—no surprise rule changes.',
  },
  {
    id: 'deposit',
    title: 'Lock stakes',
    detail:
      'Both players deposit into the escrow smart contract. Funds are not held in a custodial account; they stay locked until settlement.',
  },
  {
    id: 'play',
    title: 'Play & verify',
    detail:
      'Complete the match under your agreed rules. Outcomes are verified through your game’s process (such as player IDs or admin review), then settlement moves on-chain.',
  },
  {
    id: 'winner',
    title: 'Set winner',
    detail:
      'When the result is confirmed, an authorized settlement call records the winner on the contract—transparent and auditable.',
  },
  {
    id: 'payout',
    title: 'Payout',
    detail:
      'The contract releases the pot to the winner automatically, minus a small disclosed platform fee. No manual approval or withdrawal delays.',
  },
];

export default function ChallengeRoadmap() {
  return (
    <section
      className="challenge-roadmap"
      aria-labelledby="challenge-roadmap-heading"
    >
      <div className="challenge-roadmap__intro">
        <h2 id="challenge-roadmap-heading" className="challenge-roadmap__title">
          From challenge to payout
        </h2>
        <p className="challenge-roadmap__lede">
          Six steps from creating a bet to funds landing in the winner’s wallet.
          Hover or focus a step for more detail.
        </p>
      </div>

      <ol className="challenge-roadmap__track">
        {STEPS.map((step, index) => (
          <li key={step.id} className="challenge-roadmap__item">
            <button
              type="button"
              className="challenge-roadmap__step"
              aria-label={`${step.title}. ${step.detail}`}
            >
              <span className="challenge-roadmap__marker" aria-hidden="true">
                <span className="challenge-roadmap__marker-inner">{index + 1}</span>
              </span>
              <span className="challenge-roadmap__step-title">{step.title}</span>
              <div className="challenge-roadmap__tooltip" aria-hidden="true">
                <p className="challenge-roadmap__tooltip-text">{step.detail}</p>
              </div>
            </button>
            {index < STEPS.length - 1 ? (
              <span className="challenge-roadmap__connector" aria-hidden="true" />
            ) : null}
          </li>
        ))}
      </ol>
    </section>
  );
}
